import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/Table/index.js
// module id = 196
// module chunks = 0